import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useAddAddress, useUpdateAddress } from "../../../hooks/apis/address";
import { toast } from "react-toastify";

const MapComponent = ({ selectedAddress, closeModal }) => {
  const { mutate, isSuccess, isLoading, error } = useAddAddress();
  const {
    mutate: mutateUpdate,
    isSuccess: updateSuccess,
    isLoading: updateLoading,
    error: updateError,
  } = useUpdateAddress(selectedAddress?.id);
  const [isMarkerDraggable, setMarkerDraggable] = useState(
    selectedAddress.id ? false : true
  );
  const [markerPosition, setMarkerPosition] = useState(
    selectedAddress.id
      ? [selectedAddress.latitude, selectedAddress.longitude]
      : [36.30991, 59.361484]
  );
  const [inputErrors, setInputErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  const addressRef = useRef();

  const ChangeView = () => {
    const map = useMapEvents({
      move: () => {
        const center = map.getCenter();
        if (isMarkerDraggable) {
          setMarkerPosition([center?.lat, center?.lng]);
        }
      },
    });

    return null;
  };
  const toggleMarkerDraggable = () => {
    setMarkerDraggable(!isMarkerDraggable);
  };

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setInputErrors({});

    if (addressRef.current.value === "") {
      setInputErrors((prevState) => ({
        ...prevState,
        addressError: "لطفا آدرس خود را وارد کنید",
      }));
    } else if (addressRef.current.value.length > 100) {
      setInputErrors((prevState) => ({
        ...prevState,
        addressError: "آدرس شما نباید بیشتر از 100 کاراکتر باشد",
      }));
    } else {
      setInputErrors((prevState) => ({
        ...prevState,
        addressError: "",
      }));
    }
  };

  useEffect(() => {
    const hasAddressError = !!inputErrors.addressError;

    if (formSubmitted && !hasAddressError) {
      const latitude = String(markerPosition[0]);
      const longitude = String(markerPosition[1]);
      const address = addressRef.current.value;
      const body = { latitude, longitude, address };
      if (selectedAddress.id) {
        mutateUpdate(body);
      } else {
        mutate(body);
      }
    }
  }, [inputErrors, formSubmitted]);

  useEffect(() => {
    if (selectedAddress.id) {
      addressRef.current.value = selectedAddress.address;
    }
  }, [selectedAddress]);

  useEffect(() => {
    if (isSuccess) {
      toast.success("آدرس شما با موفقیت ثبت شد");
      closeModal(); // Call the closeModal function passed from Address_content
    }
    if (updateSuccess) {
      toast.success("آدرس شما با موفقیت ویرایش شد");
      closeModal(); // Call the closeModal function passed from Address_content
    }
  }, [isSuccess, updateSuccess]);
  return (
    <>
      <MapContainer
        center={markerPosition}
        zoom={13}
        style={{ height: "150px", width: "100%" }}
      >
        <ChangeView />

        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Draggable marker */}
        <Marker
          draggable={isMarkerDraggable}
          onDragend={(e) => setMarkerPosition(e.target.getLatLng())}
          position={markerPosition}
          icon={L.icon({
            iconUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            tooltipAnchor: [16, -28],
            shadowUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
            shadowSize: [41, 41],
          })}
        />
      </MapContainer>
      <button
        onClick={toggleMarkerDraggable}
        style={{
          background: "green",
          color: "white",
          border: "none",
          borderRadius: "5px",
          padding: "5px 10px",
          width: "100%",
          marginTop: "5px",
        }}
      >
        {!isMarkerDraggable ? "اصلاح موقعیت روی نقشه" : "تایید موقعیت روی نقشه"}
      </button>
      <div>
        <div className="my-2">
          <label style={{ fontWeight: "bolder" }}>آدرس</label>
          <input
            type="text"
            name="address"
            style={
              !inputErrors.addressError
                ? {
                    width: "100%",
                    border: "1px solid gray",
                    borderRadius: "5px",
                    outline: "none",
                    padding: "0px 5px",
                  }
                : {
                    width: "100%",
                    border: "1px solid red",
                    borderRadius: "5px",
                    outline: "none",
                    padding: "0px 5px",
                  }
            }
            ref={addressRef}
          />
          {inputErrors.addressError ? (
            <span style={{ color: "red", fontSize: "10px" }}>
              {inputErrors.addressError}
            </span>
          ) : null}
        </div>

        <button
          onClick={handleSubmitFrom}
          disabled={isLoading || updateLoading ? true : false}
          style={{
            background: "green",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "5px 10px",
            width: " 100%",
            marginTop: "5px",
          }}
        >
          {isLoading || updateLoading ? (
            <img src="/images/loading.svg" style={{ height: "30px" }} />
          ) : (
            "   ثبت آدرس"
          )}
        </button>
      </div>
    </>
  );
};

export default MapComponent;
